<template lang="pug">
  .create-cv.gray-bg
    .section(v-if="!allowAddCv")
      .container.has-text-centered
        h3 {{ gettext('Please, update your profile first') }}&nbsp;
        router-link.main-btn.col-white.bg-red(:to="{name: 'Profile', hash: '#info'}") {{gettext('Go to profile')}}
    .section(v-else)
      .container.has-text-centered
        h2 {{ $route.params.id ? gettext('Edit CV') : gettext('Create CV') }}&nbsp;
          span(v-if="edit && form.is_trainee") {{ `(${gettext('for trainee')})` }}
          span(v-else) {{edit ? `(${form.is_seasonal ? gettext('for seasonal work') : gettext('for permanent work')})` : ''}}
        .personal-profile-grid
          .main
            .field.is-horizontal(v-if="!edit")
              label.label.name {{gettext('CV type')}}
              .field-body
                dropdown-simple(:custom="true" :selected="CVType" :disabled="form.is_trainee || getUser.only_cv_type != null")
                  a.dropdown-item(@click="CVType = {name: CvTypes[CONSTANTS.TYPE_PERMANENT_WORK], is_seasonal: false}") {{ CvTypes[CONSTANTS.TYPE_PERMANENT_WORK] }}
                  a.dropdown-item(@click="CVType = {name: CvTypes[CONSTANTS.TYPE_SEASONAL_WORK], is_seasonal: true}") {{ CvTypes[CONSTANTS.TYPE_SEASONAL_WORK] }}
            .field.is-horizontal.min-height(v-if="!edit && getUser.profile_type === CONSTANTS.SENDER_PROFILE_TYPE")
              label.label.name
              .field-body
                span.radio-wrap.left
                  input.is-checkradio.custom-checkbox-box#is_trainee(
                  type="checkbox"
                  :disabled="getUser.only_cv_is_trainee != null || getUser.only_cv_type == 20"
                  name="is_trainee"
                  v-model="form.is_trainee"
                  @click="checkIsTrainee()"
                  )
                  label(for="is_trainee") {{ gettext('Is trainee') }}
            .field.is-horizontal
              label.label.name {{ gettext('Name')+'*' }}
              .field-body
                input.input(
                v-tooltip="{content: errors.field.required, show: tooltip.first_name}"
                name="first_name"
                v-model="form.first_name"
                @input="form.first_name = validateLatinCharacter($event)"
                :placeholder="gettext('Only latin letters')"
                @blur="validateData('first_name')"
                :class="{'is-danger': $v.form.first_name.$error, 'is-empty': !form.first_name}"
                )

            .field.is-horizontal
              label.label.name {{ gettext('Surname')+'*' }}
              .field-body
                input.input(
                v-tooltip="{content: errors.field.required, show: tooltip.last_name}"
                name="last_name"
                @input="form.last_name = validateLatinCharacter($event)"
                :placeholder="gettext('Only latin letters')"
                v-model="form.last_name"
                @blur="validateData('last_name')"
                :class="{'is-danger': $v.form.last_name.$error, 'is-empty': !form.last_name}"
                )

            .field.is-horizontal
              label.label.name {{ gettext('Date of birth') }}
              .field-body(@click="validateData('birth_date')")
                datepicker(
                :inputClass="'input'"
                v-model="form.birth_date"
                )

            .field.is-horizontal(v-if="getUser.profile_type === CONSTANTS.SENDER_PROFILE_TYPE")
              label.label.name {{ gettext('Original nationality') }}*
              .field-body(@click="validateData('country')")
                ajax-multiselect.is-single(
                v-model="form.country"
                :labelText="gettext('Choose the country')"
                returnItem ="id"
                itemName ="name"
                :action="{method: 'receiveCountries', params:{lang: getLanguage}}"
                :class="{'is-danger': $v.form.country.$error}"
                :multiple="false"
                :searchable="true"
                :hideSelected="true"
                :closeOnSelect="true"
                )

            .field.is-horizontal(v-if="getUser.profile_type === CONSTANTS.SENDER_PROFILE_TYPE")
                label.label.name {{ gettext('Marital status')+'*' }}
                .field-body
                  ajax-multiselect.wide(
                  v-model="form.marital_status"
                  :labelText="gettext('Choose status')"
                  returnItem ="id"
                  itemName ="name"
                  :action="{method: 'receiveMaritalStatuses', params: {lang: getLanguage}}",
                  :class="{'is-danger': $v.form.marital_status.$error}"
                  :multiple="false"
                  :searchable="true"
                  :hideSelected="true"
                  :closeOnSelect="true"
                  )

            .field.is-horizontal.gender-field(v-if="getUser.profile_type === CONSTANTS.SENDER_PROFILE_TYPE")
              label.label.name {{ gettext('Gender')+' *' }}
              .field-body.has-text-left(
              v-tooltip="{content: errors.field.required, show: tooltip.gender}"
              :class="{'is-danger': $v.form.gender.$error}"
              )
                span.radio-wrap
                  input.is-checkradio#gender-male(type="radio" name="gender" :value='10' v-model="form.gender")
                  label(for="gender-male") {{ gettext('Male') }}
                span.radio-wrap
                  input.is-checkradio#gender-female(type="radio" name="gender" :value='20' v-model="form.gender")
                  label(for="gender-female") {{ gettext('Female') }}

            .field.is-horizontal(v-if="getUser.profile_type === CONSTANTS.SENDER_PROFILE_TYPE || getUser.profile_type === CONSTANTS.JOBSEEKER_PROFILE_TYPE")
              label.label.name {{ gettext('Height (cm)') }}
              .field-body
                input.input(
                name="height"
                v-model="form.height"
                @input="form.height = validateLatinCharacter($event)"
                type="number"
                :placeholder="gettext('Height')"
                @blur="validateData('height')"
                :class="{'is-danger': $v.form.height.$error, 'is-empty': !form.height}"
                )

            .field.is-horizontal(v-if="getUser.profile_type === CONSTANTS.SENDER_PROFILE_TYPE || getUser.profile_type === CONSTANTS.JOBSEEKER_PROFILE_TYPE")
              label.label.name {{ gettext('Weight (kg)') }}
              .field-body
                input.input(
                name="weight"
                v-model="form.weight"
                @input="form.weight = validateLatinCharacter($event)"
                type="number"
                :placeholder="gettext('Weight')"
                @blur="validateData('weight')"
                :class="{'is-danger': $v.form.height.$error, 'is-empty': !form.weight}"
                )

            .field.is-horizontal
              label.label.name {{ gettext('EU Citizenship')+'*' }}
              .field-body.has-text-left(
                v-tooltip="{content: errors.field.required, show: tooltip.eu_citizenship}"
                :class="{'is-danger': $v.form.eu_citizenship.$error}"
              )
                span.radio-wrap
                  input.is-checkradio#citizenshipYes(type="radio" name="overtimes" :value='true' v-model="form.eu_citizenship")
                  label(for="citizenshipYes") {{ gettext('Yes') }}
                span.radio-wrap
                  input.is-checkradio#citizenshipNo(type="radio" name="overtimes" :value='false' v-model="form.eu_citizenship")
                  label(for="citizenshipNo") {{ gettext('No') }}

            .field.is-horizontal.linned-bottom.min-height
              label.label.name
              .field-body

            .field.is-horizontal
              label.label.font.is-pulled-left {{ gettext('Location of residence') }}
              .field-body

            .field.is-horizontal
              label.label.name {{ gettext('Country')+'*' }}
              .field-body(@click="validateData('location_country')")
                ajax-multiselect.is-single(
                v-tooltip="{content: errors.field.required, show: tooltip.location_country}"
                v-model="form.location_country"
                :labelText="gettext('Choose your country')"
                :itemName ="'name'"
                :class="{'is-danger': $v.form.location_country.$error, 'is-empty': !form.location_country.length}"
                :action="{method: 'receiveCountries', params: {lang: getLanguage}}"
                :multiple="false"
                :searchable="true"
                :hideSelected="false"
                :closeOnSelect="true"
                @updated="countryUpdateHandler()"
                @selected="getStayingTypes"
                )
            .field.is-horizontal(v-if="regionAction.params.country")
              label.label.name {{ gettext('Region')+'*' }}
              .field-body(@click="validateData('location_region')")
                ajax-multiselect.is-single(
                v-tooltip="{content: errors.required, show: tooltip.location_region}"
                v-model="form.location_region"
                :labelText="gettext('Choose the region')"
                :itemName ="'name'"
                :class="{'is-danger': $v.form.location_region.$error, 'is-empty': !form.location_region.length }"
                :action="regionAction",
                :multiple="false"
                :searchable="true"
                :hideSelected="true"
                :closeOnSelect="true"
                :disabled="!form.location_country.id"
                )
            .field.is-horizontal
              label.label.name {{ gettext('City')+'*' }}
              .field-body(@click="validateData('location_city')")
                input.input(
                v-tooltip="{content: errors.field.required, show: tooltip.location_city}"
                name="location_city"
                @input="form.location_city = validateLatinCharacter($event)"
                :placeholder="gettext('Only latin letters')"
                v-model="form.location_city"
                @blur="validateData('location_city')"
                :class="{'is-danger': $v.form.location_city.$error, 'is-empty': !form.location_city}"
                )

            .field.is-horizontal
              label.label.name {{ gettext('Zip code')+'*' }}
              .field-body(@click="validateData('location_zip')")
                input.input(
                v-tooltip="{content: $v.form.location_zip.integer ? (errors.field.integer) : ($v.form.location_zip.maxLength ? errors.field.required : errors.field.maxLength), show: tooltip.location_zip}"
                name="location_zip"
                type="number"
                v-model="form.location_zip"
                @blur="validateData('location_zip')"
                :class="{'is-danger': $v.form.location_zip.$error, 'is-empty': !form.location_zip || $v.form.location_zip.$error}"
                )

            .field.is-horizontal.flex-start(v-if="(stayingTypes || []).length")
              label.label.name {{ gettext('Staying type')+'*' }}
              .field-body.has-text-left.grid-checkboxes(
              v-tooltip="{content: errors.field.required, show: tooltip.location_staying_type}"
              :class="{'is-danger': $v.form.location_staying_type.$error}"
              )
                span.radio-wrap(v-for="item in stayingTypes")
                  input.is-checkradio(:id="'stayingType'+item.id" type="radio" name="stayingType" :value='item.id' v-model="form.location_staying_type")
                  label(:for="'stayingType'+item.id") {{ item.name }}

            .field.is-horizontal.linned-bottom.min-height
              label.label.name
              .field-body

            .field.is-horizontal
              label.label.font.is-pulled-left {{ gettext('Contact information') }}
              .field-body

            .field.is-horizontal
              label.label.name {{ gettext('Email')+'*' }}
              .field-body
                input.input(
                name="email"
                v-tooltip="{content: errors.field.invalid, show: tooltip.email}"
                v-model="form.email"
                @blur="validateData('email')"
                :class="{'is-danger': $v.form.email.$error, 'is-empty': !form.email}"
                )

            .field.is-horizontal
              label.label.name {{ gettext('Phone')+'*' }}
              .field-body
                v-phone-input(
                name="phone"
                v-tooltip="{content: errors.server.phone || errors.field.required, show: tooltip.phone}"
                v-model="form.phone"
                @blur="validateData('phone')"
                :class="{'is-danger': $v.form.phone.$error, 'is-empty': !form.phone}"
                @onInput="form.phone = $event.number"
                :phone="form.phone"
                )

            .field.is-horizontal
              label.label.name {{ gettext('Skype') }}
              .field-body
                input.input(
                name="skype"
                v-model="form.skype"
                )

            .field.is-horizontal
              label.label.name {{ gettext('Facebook') }}
              .field-body
                input.input(
                name="facebook"
                v-model="form.facebook"
                v-tooltip="{content: errors.server.facebook, show: tooltip.facebook}"
                :class="{'is-danger is-empty': tooltip.facebook}"
                :placeholder="interpolate(gettext('Example: %s'), ['facebook.com/bixterwork'])"
                )

            .field.is-horizontal
              label.label.name {{ gettext('Linkedin') }}
              .field-body
                input.input(
                name="facebook"
                v-model="form.linkedin"
                v-tooltip="{content: errors.server.facebook, show: tooltip.facebook}"
                :class="{'is-danger is-empty': tooltip.facebook}"
                :placeholder="interpolate(gettext('Example: %s'), ['linkedin.com/bixterwork'])"
                )

            .field.is-horizontal.linned-bottom.min-height
              label.label.name
              .field-body

            work-profession#profession(
            ref="profession"
            :tooltip="errors.block"
            :seasonal="form.is_seasonal"
            :ready="ready"
            v-model="form.professionData"
            )

            .field.is-horizontal.linned-bottom.min-height
              label.label.name
              .field-body

            .field.is-horizontal.vertical
              label.label.name.is-pulled-left {{ gettext('About yourself') }}
              .field-body
                textarea.textarea(
                rows="7"
                @input="form.about = validateLatinCharacter($event)"
                :placeholder="gettext('Only latin letters')"
                v-model="form.about"
                )

            .field.is-horizontal.linned-bottom.min-height
              label.label.name
              .field-body
            work-experiences#experiences(
            ref="experiences"
            :experience="form.experience"
            :tooltip="errors.block"
            v-model="form.work_experiences"
            @experience="setExperience"
            )
            .field.is-horizontal.linned-bottom.min-height
              label.label.name
              .field-body

            work-educations#educations(
            ref="educations"
            :tooltip="errors.block"
            v-model="form.educations"
            )
              template(slot="addition-items-head")
                .field.is-horizontal.min-height
                  label.label.name
                    span.radio-wrap.left
                      input.is-checkradio.custom-checkbox-box#has-relevant-education(
                      type="checkbox"
                      name="has-relevant-education"
                      v-model="form.has_relevant_education"
                      )
                      label(for="has-relevant-education") {{ gettext('I have got a relevant education to the profession') }}
                  .field-body
            .field.is-horizontal.linned-bottom.min-height
              label.label.name
              .field-body

            work-languages#languages(
            ref="languages"
            :tooltip="errors.block"
            v-model="form.languages"
            )
            .field.is-horizontal.linned-bottom.min-height
              label.label.name
              .field-body

            .field.is-horizontal
              label.label.name.is-pulled-left  {{ gettext('Driver`s license') }}
              .field-body
                ajax-multiselect(
                v-model="form.driving_licences"
                :itemName ="'name'"
                :action="{method: 'receiveDrivingLicences', params: {lang: getLanguage}}"
                )

            .field.is-horizontal.linned-bottom.min-height
              label.label.name
              .field-body

            .field.is-horizontal
              v-upload(
                :title="gettext('Upload files')"
                :uploadAction="actionUploadFiles"
                :accept="'application/pdf'"
                :extensions="['pdf']"
                :thumbs="false"
                v-model="form.documents"
                :setData="documents"
                @active="imageLoading = $event"
              )

            .field.is-horizontal
              .field-body
                button.main-btn.col-white.bg-red.btn-big(
                @click="send"
                :disabled="imageLoading"
                v-scroll-to="{ element: '.is-empty', easing: 'linear', offset: -100 }"
                )
                  span(v-if="!imageLoading") {{ edit ? gettext('Update CV') : gettext('Publish CV') }}
                  span(v-else) {{ gettext('Processing...') }}

          .right
            image-cropper(
            ref="imageCropper"
            :cropButtonText="gettext('Crop image')"
            :rotateButtonText="gettext('Rotate')"
            :rotate="true"
            :customStrings="{ drag: gettext('Upload image'), change: gettext('Change Photo'), remove: gettext('Remove Photo') }"
            v-model="image"
            @cropped="loadImage",
            @remove="form.image_imgid = ''"
            @update="cropped = !cropped"
            )
</template>

<script>
import Vue from 'vue'
import {gettext, interpolate} from '@/services/TranslateHandler'
import {mapGetters, mapActions, mapMutations} from 'vuex'
import AjaxDropdown from '@/components/ajax-dropdown'
import Datepicker from '@/components/datepicker'
import WorkExperiences from './parts/work-experience'
import WorkEducations from './parts/work-education'
import WorkLanguages from './parts/work-languages'
import WorkProfession from './parts/work-profession'
import ImageCropper from '@/components/image-cropper'
import AjaxMultiselect from '@/components/ajax-multiselect'
import Vuelidate from 'vuelidate'
import { required, email, maxLength, numeric } from 'vuelidate/lib/validators'
import VTooltip from 'v-tooltip'
import VPhoneInput from '@/components/v-phone-input'
import DropdownSimple from '@/components/dropdown-simple'
import VUpload from '@/components/upload-files'
import mixin from '@/mixins'
const VueScrollTo = require('vue-scrollto')
const _ = require('lodash')
const toastr = require('toastr')
const CONSTANTS = require('@/constants.json')

Vue.use(VTooltip, {
  defaultTrigger: 'manual'
})
Vue.use(VueScrollTo)

Vue.use(Vuelidate)

export default {
  name: 'CV',
  mixins: [
    mixin
  ],
  components: {
    AjaxMultiselect,
    AjaxDropdown,
    Datepicker,
    WorkExperiences,
    WorkEducations,
    WorkLanguages,
    WorkProfession,
    ImageCropper,
    VPhoneInput,
    VUpload,
    DropdownSimple
  },
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo})
  },
  data () {
    return {
      CVType: {name: gettext('Permanent work'), is_seasonal: false},
      image: '',
      documents: [],
      cropped: false,
      imageLoading: false,
      edit: !!this.$route.params.id,
      tooltip: {},
      CONSTANTS: CONSTANTS,
      ready: false,
      form: {
        first_name: '',
        last_name: '',
        professionData: {},
        is_seasonal: false,
        has_relevant_education: false,
        marital_status: '',
        birth_date: '',
        eu_citizenship: null,
        country: {},
        gender: null,
        height: '',
        weight: '',
        email: '',
        phone: '',
        skype: '',
        facebook: '',
        linkedin: '',
        image_imgid: '',
        experience: true,
        work_experiences: [],
        educations: [],
        languages: [],
        driving_licences: [],
        about: '',
        is_active: true,
        documents: [],
        location_country: {},
        location_region: {},
        location_city: '',
        location_zip: '',
        location_staying_type: '',
        is_trainee: false
      },
      stayingTypes: [],
      errors: {}
    }
  },
  validations () {
    let profileType = this.getUser.profile_type
    if (profileType === this.CONSTANTS.SENDER_PROFILE_TYPE) {
      return {
        form: {
          first_name: {required},
          last_name: {required},
          country: {required},
          marital_status: {required},
          email: {required, email},
          phone: {required},
          eu_citizenship: {required},
          gender: {required},
          height: {numeric},
          weight: {numeric},
          location_country: {required},
          location_region: {required},
          location_city: {required},
          location_zip: {required, maxLength: maxLength(10)},
          location_staying_type: {required},
          is_trainee: {}
        }
      }
    } else {
      return {
        form: {
          first_name: {required},
          last_name: {required},
          email: {required, email},
          phone: {required},
          eu_citizenship: {required},
          height: {numeric},
          weight: {numeric},
          location_country: {required},
          location_region: {required},
          location_city: {required},
          location_zip: {required, maxLength: maxLength(10)},
          location_staying_type: {required}
        }
      }
    }
  },
  methods: {
    ...mapMutations([
      'changeReRenderPageCounter'
    ]),
    ...mapActions([
      'jobseekerCreateCV',
      'jobseekerUpdateCV',
      'jobseekerGetCV',
      'uploadImage',
      'addSenderCv',
      'receiveSenderCv',
      'updateSenderCv',
      'uploadFile',
      'receiveStayingTypes'
    ]),
    gettext: gettext,
    interpolate: interpolate,
    checkIsTrainee () {
      this.$nextTick(() => {
        if (this.form.is_trainee) {
          this.CVType = {name: this.CvTypes[CONSTANTS.TYPE_PERMANENT_WORK], is_seasonal: false}
        }
      })
    },
    imageNormalize (img) {
      if (img) return img.replace(/.*(,)/, '')
    },
    countryUpdateHandler () {
      this.form.location_staying_type = ''
      this.form.location_region = {}
    },
    getStayingTypes () {
      this.receiveStayingTypes({lang: this.getLanguage, id: this.form.location_country.id}).then(res => {
        this.stayingTypes = res
      })
    },
    loadImage (value) {
      return new Promise(resolve => {
        if (value) {
          this.imageLoading = true
          this.uploadImage({lang: this.getLanguage, img: this.imageNormalize(value), profile: 'cv'}).then(res => {
            this.image = res.variants.mid.full_url
            this.form.image_imgid = res.imgid
            this.imageLoading = false
            resolve(res)
          })
        }
      })
    },
    async actionUploadFiles (file, progress) {
      let result = await this.uploadFile({lang: this.getLanguage, document: this.imageNormalize(file.base64), profile: 'cv', progressHandler: progress})
      file.fileID = result.docid
      file.preview = result.thumbnails.md.path
    },
    formatter (data, child, attr = 'id') {
      if (child) {
        for (let key in data) {
          if (Array.isArray(data[key][child])) {
            _.each(data[key][child], (childItem, k) => {
              if (typeof childItem === 'number') {
                data[key][child][k] = childItem
              } else {
                data[key][child][k] = childItem[attr]
              }
            })
          } else {
            if (typeof data[0] !== 'object') {
              data[key] = data[key][attr]
            } else {
              data[key] = []
            }
          }
        }
      } else if (typeof data[0] === 'number') {
        return data
      } else {
        if (data.length > 0) {
          _.each(data, (item, key) => {
            data[key] = item[attr]
          })
        }
      }
      return data
    },
    validateData (item) {
      if (item) {
        this.$v.form[item].$touch()
        if (this.$v.form[item].$error) {
          this.$set(this.tooltip, item, true)
        }
        setTimeout(() => {
          this.tooltip[item] = false
        }, 3000)
      } else {
        this.$v.$touch()
        let errors = this.$v.form
        _.each(errors, (item, key) => {
          if (!key.includes('$')) {
            if (errors[key].$error) {
              this.$set(this.tooltip, key, true)
            }
          }
        })
        setTimeout(() => {
          _.each(this.tooltip, (item, key) => {
            this.tooltip[key] = false
          })
        }, 3000)
      }
    },
    send () {
      this.validateData()
      if (this.$route.params.id) this.updateCV()
      else this.createCV()
    },
    formatWorkExperience (data) {
      let res = _.map(data, item => _.omit(item, 'id'))
      return _.map(res, item => {
        item.profession = item.profession.id || null
        if (item.period_to === 0) {
          item.period_to = null
        }
        return item
      })
    },
    formatEducation (data) {
      data = _.map(data, item => _.omit(item, 'id'))
      return data.map(item => {
        if (item.period_to === 0) {
          item.period_to = null
        }
        return item
      })
    },
    getFormData () {
      let profileType = this.getUser.profile_type
      if (profileType === this.CONSTANTS.SENDER_PROFILE_TYPE) {
        return {
          first_name: this.form.first_name,
          last_name: this.form.last_name,
          birth_date: this.form.birth_date || null,
          marital_status: parseInt(this.form.marital_status) || null,
          gender: this.form.gender,
          height: parseInt(this.form.height) || null,
          weight: parseInt(this.form.weight) || null,
          eu_citizenship: this.form.eu_citizenship,
          country: this.form.country,
          email: this.form.email,
          phone: this.form.phone,
          skype: this.form.skype,
          facebook: this.form.facebook,
          linkedin: this.form.linkedin,
          driving_licences: this.form.driving_licences ? this.formatter(this.form.driving_licences) : [],
          about: this.form.about,
          work_experiences: (this.form.experience && !this.$refs.experiences.$v.$invalid) ? this.formatWorkExperience(this.form.work_experiences) : [],
          educations: this.formatEducation(this.form.educations),
          languages: _.map(this.form.languages, item => _.omit(item, 'id')),
          image_imgid: this.form.image_imgid,
          is_active: this.edit ? this.form.is_active : undefined,
          type: !this.edit ? (this.form.is_seasonal ? CONSTANTS.TYPE_SEASONAL_WORK : CONSTANTS.TYPE_PERMANENT_WORK) : undefined,
          has_profession: !this.form.professionData.noProfession,
          has_relevant_education: this.form.has_relevant_education,
          profession: !this.form.professionData.noProfession && !this.form.is_seasonal ? this.form.professionData.profession : null,
          profession_company_type: !this.form.professionData.noProfession ? this.form.professionData.profession_company_type : null,
          profession_company_sector: !this.form.professionData.noProfession && !this.form.is_seasonal ? this.form.professionData.profession_company_sector : null,
          documents: (this.form.documents[0] || {}).fileID ? _.map(this.form.documents, item => item.fileID) : this.form.documents,
          location_country: (this.form.location_country || {}).id || (this.form.location_country[0] || {}).id,
          location_region: (this.form.location_region || {}).id || (this.form.location_region[0] || {}).id,
          location_city: this.form.location_city,
          location_zip: this.form.location_zip,
          location_staying_type: this.form.location_staying_type,
          is_trainee: this.form.is_trainee
        }
      } else {
        return {
          first_name: this.form.first_name,
          last_name: this.form.last_name,
          birth_date: this.form.birth_date || null,
          eu_citizenship: this.form.eu_citizenship,
          height: parseInt(this.form.height) || null,
          weight: parseInt(this.form.weight) || null,
          email: this.form.email,
          phone: this.form.phone,
          skype: this.form.skype,
          facebook: this.form.facebook,
          linkedin: this.form.linkedin,
          driving_licences: this.form.driving_licences ? this.formatter(this.form.driving_licences) : [],
          about: this.form.about,
          work_experiences: (this.form.experience && !this.$refs.experiences.$v.$invalid) ? this.formatWorkExperience(this.form.work_experiences) : [],
          educations: this.formatEducation(this.form.educations),
          languages: _.map(this.form.languages, item => _.omit(item, 'id')),
          image_imgid: this.form.image_imgid,
          is_active: this.edit ? this.form.is_active : undefined,
          type: !this.edit ? (this.form.is_seasonal ? CONSTANTS.TYPE_SEASONAL_WORK : CONSTANTS.TYPE_PERMANENT_WORK) : undefined,
          has_profession: !this.form.professionData.noProfession,
          has_relevant_education: this.form.has_relevant_education,
          profession: !this.form.professionData.noProfession && !this.form.is_seasonal ? this.form.professionData.profession : null,
          profession_company_type: !this.form.professionData.noProfession ? this.form.professionData.profession_company_type : null,
          profession_company_sector: !this.form.professionData.noProfession && !this.form.is_seasonal ? this.form.professionData.profession_company_sector : null,
          documents: (this.form.documents[0] || {}).fileID ? _.map(this.form.documents, item => item.fileID) : this.form.documents,
          location_country: (this.form.location_country || {}).id || (this.form.location_country[0] || {}).id,
          location_region: (this.form.location_region || {}).id || (this.form.location_region[0] || {}).id,
          location_city: this.form.location_city,
          location_zip: this.form.location_zip,
          location_staying_type: this.form.location_staying_type
        }
      }
    },
    setFormData (data) {
      _.each(data, (item, key) => {
        if (((key in this.form) && item) || ((key in this.form) && _.isBoolean(item))) {
          this.form[key] = item
        }
      })
      if (data.image_urls) {
        this.image = data.image_urls.mid
      }
      if (data.documents.length) {
        this.documents = _.map(data.documents, (item, key) => {
          return {
            id: item,
            fileID: item,
            preview: data.documents_urls[key].md,
            success: true,
            active: false
          }
        })
      }
      this.form.professionData = {
        noProfession: !data.has_profession,
        profession: data.profession,
        profession_company_type: data.profession_company_type,
        profession_company_sector: data.profession_company_sector
      }
      this.form.experience = !!data.work_experiences.length
      this.CVType = {name: this.CvTypes[data.type], is_seasonal: data.type === CONSTANTS.TYPE_SEASONAL_WORK}
      this.setOnlyCvParams()
      this.ready = true
    },
    setOnlyCvParams () {
      if (this.$route.params.id) return
      if (this.getUser.only_cv_type != null) {
        this.CVType = {
          name: this.CvTypes[this.getUser.only_cv_type],
          is_seasonal: this.getUser.only_cv_type !== 10
        }
      }
      if (this.getUser.only_cv_is_trainee != null) {
        this.form.is_trainee = this.getUser.only_cv_is_trainee
      }
    },
    createCV () {
      this.checkValidation()
      if (this.formIsValid) {
        let profileType = this.getUser.profile_type
        if (profileType === this.CONSTANTS.SENDER_PROFILE_TYPE) {
          this.addSenderCv({lang: this.getLanguage, data: this.getFormData()}).then(res => {
            this.$router.push({name: 'Dashboard', params: {lang: this.getLanguage}})
          }).catch((err) => {
            if ((err.data || {}).form_errors) {
              this.errorProcessor(err.data.form_errors)
              toastr.error(gettext('Validation error!'), gettext('Error!'))
            }
          })
        } else {
          this.jobseekerCreateCV({lang: this.getLanguage, data: this.getFormData()}).then(res => {
            window.localStorage.setItem('createCvReminder', true)
            this.$router.push({name: 'MyCVS', params: {lang: this.getLanguage}})
          }).catch((err) => {
            if ((err.data || {}).form_errors) {
              this.errorProcessor(err.data.form_errors)
              toastr.error(gettext('Validation error!'), gettext('Error!'))
            }
          })
        }
      } else {
        toastr.warning(gettext('Please fill all required fields'), gettext('Warning!'))
      }
    },
    updateCV () {
      this.checkValidation()
      if (this.formIsValid) {
        let profileType = this.getUser.profile_type
        if (profileType === this.CONSTANTS.SENDER_PROFILE_TYPE) {
          this.updateSenderCv({lang: this.getLanguage, data: this.getFormData(), id: parseInt(this.$route.params.id)}).then(() => {
            this.$router.push({name: 'Dashboard', params: {lang: this.getLanguage}})
          }).catch((err) => {
            if ((err.data || {}).form_errors) {
              this.errorProcessor(err.data.form_errors)
              toastr.error(gettext('Validation error!'), gettext('Error!'))
            }
          })
        } else {
          this.jobseekerUpdateCV({lang: this.getLanguage, data: this.getFormData(), id: parseInt(this.$route.params.id)}).then(() => {
            this.$router.push({name: 'MyCVS', params: {lang: this.getLanguage}})
          }).catch((err) => {
            if ((err.data || {}).form_errors) {
              this.errorProcessor(err.data.form_errors)
              toastr.error(gettext('Validation error!'), gettext('Error!'))
            }
          })
        }
      } else {
        toastr.warning(gettext('Please fill all required fields'), gettext('Warning!'))
      }
    },
    checkValidation () {
      this.$v.$touch()
      if (this.form.experience) this.$refs.experiences.validateData()
      if (!(this.form.professionData || {}).noProfession) this.$refs.profession.validateData()
      this.$refs.languages.validateData()
      this.$refs.educations.validateData()
    },
    setExperience (val) {
      this.form.experience = val
    },
    errorProcessor (error) {
      _.each(error, (item, key) => {
        if (_.has(this.form, key)) {
          this.form[key] = ''
          this.$set(this.errors.server, key, item[0].message)
          this.$set(this.tooltip, key, true)
        }
        this.checkValidation()
      })
    },
    setErrorsText () {
      this.errors = {
        field: {
          required: gettext('This field is required'),
          integer: gettext('Please enter integers'),
          backend: '',
          maxLength: interpolate(gettext('This field is not valid. The maximum number of characters is %s'), [10]),
          invalid: gettext('This field is not valid')
        },
        block: gettext('Please fill in all the highlighted fields'),
        server: {}
      }
    },
    preloadData () {
      if (this.$route.params.id) {
        let profileType = this.getUser.profile_type
        if (profileType === this.CONSTANTS.SENDER_PROFILE_TYPE) {
          this.receiveSenderCv(parseInt(this.$route.params.id)).then(res => {
            this.setFormData(res.cv)
          }).catch(() => {
            toastr.error(gettext('Server error!'), gettext('Error!'))
          })
        } else {
          this.jobseekerGetCV(parseInt(this.$route.params.id)).then(res => {
            this.setFormData(res.cv)
          }).catch(() => {
            toastr.error(gettext('Server error!'), gettext('Error!'))
          })
        }
      } else {
        let data = this.$store.state.user
        this.form.first_name = data.first_name
        this.form.last_name = data.last_name
        this.form.birth_date = data.birth_date
        this.form.email = data.email
        if (data.avatar_urls) {
          this.image = data.avatar_urls.mid
          this.form.image_imgid = data.avatar_imgid
        }
        this.setOnlyCvParams()
        this.ready = true
      }
    },
    checkType () {
      if (this.$route.query.type === 'seasonal' && !this.edit) {
        this.CVType = {name: this.CvTypes[CONSTANTS.TYPE_SEASONAL_WORK], is_seasonal: true}
        return true
      }
      return false
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage',
      'getUser'
    ]),
    allowAddCv () {
      if (
        this.getUser.profile_type === CONSTANTS.JOBSEEKER_PROFILE_TYPE &&
        (!this.getUser.location_country ||
        !this.getUser.location_region ||
        !this.getUser.location_staying_type)
      ) {
        return false
      }
      return true
    },
    regionAction () {
      return {
        method: 'receiveRegions',
        params: {
          lang: this.getLanguage,
          country: this.form.location_country.id ? this.form.location_country.iso2 : '',
          sortBy: 'name'
        }
      }
    },
    defaultMetaInfo () {
      return {
        title: this.$route.params.id ? 'Bixter | ' + gettext('Edit CV') : 'Bixter | ' + gettext('Create CV'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    },
    formIsValid: function () {
      return (!this.$v.$invalid && ((this.$refs.experiences.formIsValid && this.form.experience) || !this.form.experience) && !this.$refs.languages.$v.$invalid && !this.$refs.educations.$v.$invalid && !this.$refs.languages.$v.$invalid)
    },
    CvTypes: function () {
      return {
        [CONSTANTS.TYPE_PERMANENT_WORK]: gettext('Permanent work'),
        [CONSTANTS.TYPE_SEASONAL_WORK]: gettext('Seasonal work')
      }
    }
  },
  watch: {
    getLanguage: function () {
      this.setErrorsText()
    },
    $route: function () {
      this.changeReRenderPageCounter()
    },
    CVType: {
      deep: true,
      handler: function (val) {
        this.form.is_seasonal = val.is_seasonal
      }
    }
  },
  created () {
    this.checkType()
    this.setErrorsText()
    this.preloadData()
  }
}
</script>

<style lang='scss' src='./styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/profile/cvs/cv/index.vue